import Vue from 'vue'
import {
  login,
  logout
} from "@/api/login"
import {
  ACCESS_TOKEN,
  USER_NAME,
  USER_INFO,
  USER_AUTH,
  SYS_BUTTON_AUTH,
  ORG_CODE,
  USER_ID,
  USER_ROLE_INFO
} from "@/store/mutation-types"
import {
  welcome
} from "@/utils/util"
import {
  // queryPermissionsByUser
  queryPermissionsByUserAndOrgCode
} from '@/api/api'
import {queryRoleByUserId,queryUserExpertInfo, queryUserRole, queryUserRoleMap} from "../../api/api";
import {USER_EXPERT_ID, USER_ROLE, USER_ROLE_CODE} from "../mutation-types";

const user = {
  state: {
    token: '',
    username: '',
    realname: '',
    welcome: '',
    avatar: '',
    permissionList: [],
    info: {}
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, {
      username,
      realname,
      welcome
    }) => {
      state.username = username
      state.realname = realname
      state.welcome = welcome
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_PERMISSIONLIST: (state, permissionList) => {
      state.permissionList = permissionList
    },
    SET_INFO: (state, info) => {
      state.info = info
    },
  },

  actions: {
    // 登录
    Login({
      commit
    }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(response => {
          if (response.code == '200') {
            const result = response.result
            const userInfo = result.userInfo
            const roleInfo = result.roleinfo
            console.log("role info :", roleInfo)
            Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
            Vue.ls.set(USER_NAME, userInfo.username, 7 * 24 * 60 * 60 * 1000)
            Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
            Vue.ls.set(USER_ID, userInfo.id, 7 * 24 * 60 * 60 * 1000)
            Vue.ls.set(USER_ROLE_INFO, roleInfo, 7 * 24 * 60 * 60 * 1000)
            // Vue.ls.set(ORG_CODE, userInfo.orgCode, 7 * 24 * 60 * 60 * 1000)
            // queryUserExpertInfo({ userid: userInfo.id }).then(res => {
            //   if (res.success && res.result.records.length > 0) {
            //     let records = res.result.records;
            //     let expertId = records[0].id;
            //     Vue.ls.set(USER_EXPERT_ID,expertId,7 * 24 * 60 * 60 * 1000);
            //     console.log("expertId:"+expertId);
            //   } else {
            //     console.log(res.message)
            //   }
            // });
            queryRoleByUserId({ userid: userInfo.id }).then(res => {
              if (res.success && res.result.length > 0) {
                let result1 = res.result;
                let roleCodeAll = "";
                for(let a = 0 ; a < result1.length ; a++){
                  roleCodeAll += result1[a].roleCode;
                  if (a != result1.length -1 ) roleCodeAll += ",";
                }
                Vue.ls.set(USER_ROLE_CODE,roleCodeAll,7 * 24 * 60 * 60 * 1000)
              } else {
                console.log(res.message)
              }
            })
            commit('SET_TOKEN', result.token)
            commit('SET_INFO', userInfo)
            commit('SET_NAME', {
              username: userInfo.username,
              realname: userInfo.realname,
              welcome: welcome()
            })
            commit('SET_AVATAR', userInfo.avatar)
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetPermissionList({
      commit
    }) {
      return new Promise((resolve, reject) => {
        // let v_token = Vue.ls.get(ACCESS_TOKEN);
        // let params = {
        //   token: v_token
        // };
                // let orgCode = Vue.ls.get(ORG_CODE);
                // let params = {
                //   orgCode: orgCode
                // };
        let params = {}

        queryPermissionsByUserAndOrgCode(params).then(response => {
          const menuData = response.result.menu;
          const authData = response.result.auth;
          const allAuthData = response.result.allAuth;
          //Vue.ls.set(USER_AUTH,authData);
          sessionStorage.setItem(USER_AUTH, JSON.stringify(authData));
          sessionStorage.setItem(SYS_BUTTON_AUTH, JSON.stringify(allAuthData));
          if (menuData && menuData.length > 0) {
            commit('SET_PERMISSIONLIST', menuData)
          } else {
            reject('getPermissionList: permissions must be a non-null array !')
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    Logout({
      commit,
      state
    }) {
      return new Promise((resolve) => {
        let logoutToken = state.token;
          commit('SET_TOKEN', '')
          commit('SET_PERMISSIONLIST', [])
          Vue.ls.remove(ACCESS_TOKEN)
          Vue.ls.remove(ORG_CODE)
          Vue.ls.remove(USER_NAME)
          Vue.ls.remove(USER_INFO)
          Vue.ls.remove(USER_ID)
          Vue.ls.remove(USER_ROLE_CODE)
          Vue.ls.remove(USER_EXPERT_ID)
          Vue.ls.remove(USER_ROLE)
          Vue.ls.remove(USER_AUTH)
          sessionStorage.removeItem(USER_AUTH)
          sessionStorage.removeItem(SYS_BUTTON_AUTH)
        logout(logoutToken).then(() => {
          resolve()
        }).catch(() => {
          resolve()
        })
      })
    },

  }
}

export default user